<template>
  <div class="q-pa-lg">
    <div class="text-body1 text-weight-bold q-mb-sm">
      Account Handle
    </div>
    <div v-if="!editing" class="row items-center">
      <div class="col">
        <span v-if="account.username" class="text-body1">
          @{{ account.username }}
        </span>
        <span v-else class="text-body1 text-grey">
          Not set
        </span>
        <a
          v-if="account.profileUrl"
          :href="account.profileUrl"
          target="_blank"
          class="q-ml-sm text-primary"
        >
          <q-icon name="fa fa-external-link-alt" size="xs" />
        </a>
      </div>
      <div class="col-auto">
        <q-btn
          label="Edit"
          color="primary"
          flat
          dense
          no-caps
          @click="startEditing"
        />
      </div>
    </div>
    <div v-else>
      <q-input
        v-model="username"
        label="Username / Handle"
        :loading="saving"
        hint="Enter the account username without the @ symbol"
        outlined
        dense
        @keyup.enter="save"
      >
        <template v-slot:prepend>
          <span class="text-grey">@</span>
        </template>
      </q-input>
      <div class="q-mt-md q-gutter-sm">
        <q-btn
          label="Save"
          color="primary"
          :loading="saving"
          :disable="saving"
          no-caps
          @click="save"
        />
        <q-btn
          label="Cancel"
          color="grey"
          flat
          :disable="saving"
          no-caps
          @click="cancel"
        />
      </div>
      <div v-if="error" class="text-negative q-mt-sm">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Account } from '@/social/types';
import { update } from '.';

interface Data {
  editing: boolean;
  username: string;
  saving: boolean;
  error: string|null;
}

export default defineComponent({
  emits: ['update:account'],
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  data(): Data {
    return {
      editing: false,
      username: '',
      saving: false,
      error: null,
    };
  },
  methods: {
    startEditing(): void {
      this.username = this.account.username || '';
      this.editing = true;
      this.error = null;
    },
    cancel(): void {
      this.editing = false;
      this.error = null;
    },
    async save(): Promise<void> {
      this.saving = true;
      this.error = null;
      try {
        const username = (this.username || '').trim() || null;
        const updatedAccount = await update(this.account.id, { username });
        this.$emit('update:account', updatedAccount);
        this.editing = false;
      } catch (e) {
        this.error = 'Failed to update username. Please try again.';
      } finally {
        this.saving = false;
      }
    },
  },
});
</script>
